import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Chip,
  SelectChangeEvent
} from "@mui/material";
import {
  Add,
  Delete,
  Download,
  FilterList,
  MoreVert,
  Search,
  FirstPage,
  LastPage,
  Close,
  PhotoCamera,
  Remove,
  Edit,
  Visibility,
  Assessment
} from "@mui/icons-material";
import "../../../shared/components/Item.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";
import Autocomplete from "@mui/material/Autocomplete";

// Services - perlu disesuaikan dengan service building assessment
import {
  BuildingAssessmentSearchParams,
  getBuildingAssessments,
  createBuildingAssessment,
  updateBuildingAssessment,
  deleteBuildingAssessment,
  getAssessmentDetails,
  createAssessmentDetail,
  updateAssessmentDetail,
  deleteAssessmentDetail
} from "../services/buildingAssessmentService.tsx";
import { getOfficeProjects } from "../services/projectDetailServices.tsx";

// Date Picker
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';

import { 
  assessmentTypes, 
  statusOptions, 
  conditionOptions, 
  sipilMasterData 
} from "../constants/assessmentConfig.ts";

const BuildingAssessmentPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddAssessmentDialog, setOpenAddAssessmentDialog] = useState(false);
  const [openAssessmentDetailDialog, setOpenAssessmentDetailDialog] = useState(false);

  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "officeName", value: "" }]);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);

  const [officeOptions, setOfficeOptions] = useState<any[]>([]);
  const [currentAssessmentId, setCurrentAssessmentId] = useState<string>("");
  const [assessmentDetails, setAssessmentDetails] = useState<any[]>([]);

  const [assessmentData, setAssessmentData] = useState<any>({
    officeId: "",
    assessmentDate: dayjs().format("YYYY-MM-DD"),
    picName: "",
    assessmentType: "",
    status: "DRAFT"
  });

  const [selectedOffice, setSelectedOffice] = useState<any>({});

  const [assessmentDetailData, setAssessmentDetailData] = useState<{
    subSection: string;
    damageItem: string;
    condition: string;
    length?: number;
    width?: number;
    height?: number;
    notes: string;
    evidenceFile: File | null;
  }>({
    subSection: "",
    damageItem: "",
    condition: "",
    length: 0,
    width: 0,
    height: 0,
    notes: "",
    evidenceFile: null
  });


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const fetchOfficeList = async () => {
    try {
      const result = await getOfficeProjects({ limit: 10000000 });
      setOfficeOptions(result.data);
    } catch (error) {
      console.error("Failed to fetch offices:", error);
    }
  };

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1);
  };

  const fetchAssessments = async () => {
    setIsLoading(true);
    try {
      const result = await getBuildingAssessments({
        keyword: searchQuery,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });

      setRows(result.data || []);
      if (result.pagination) {
        setTotalPages(result.pagination.totalPages);
        setTotalItems(result.total);
      }
    } catch (err: any) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Gagal memuat data",
        text: err.response?.data?.message || "Terjadi kesalahan pada server",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOfficeList();
    fetchAssessments();
  }, [currentPage, rowsPerPage, searchQuery, sortConfig]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAssessmentData({ ...assessmentData, [name]: value });
  };

  const handleOfficeChange = (e: any) => {
    console.log("eeeeeeeeeeeeeeeeeeeeeeeeee", e);
    const officeId = e.target.value as string;
    const selectedOffice = officeOptions.find(office => office.officeId === officeId);
    console.log("ffffffffffffffffffffffffff", selectedOffice);

    setAssessmentData({ ...assessmentData, officeId });

    if (selectedOffice) {
      setSelectedOffice(selectedOffice);
    } else {
      setSelectedOffice({});
    }
  };

  const handleAssessmentDetailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAssessmentDetailData({ ...assessmentDetailData, [name]: value });
  };

  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => {
        await deleteBuildingAssessment(id.toString());
      }));

      Swal.fire({
        icon: "success",
        title: "Assessment berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchAssessments();
      setOpenDeleteDialog(false);
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus assessment",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const validateAssessmentForm = () => {
    if (!assessmentData.officeId) {
      Swal.fire({
        icon: "error",
        title: "Data Belum Lengkap",
        text: "Office Name harus diisi",
      });
      return false;
    }

    if (!assessmentData.assessmentType) {
      Swal.fire({
        icon: "error",
        title: "Data Belum Lengkap",
        text: "Assessment Type harus diisi",
      });
      return false;
    }

    return true;
  };

  const handleSubmitAssessment = async () => {
    if (!validateAssessmentForm()) return;

    try {
      if (assessmentData.id) {
        // Update existing assessment
        await updateBuildingAssessment(assessmentData.id, assessmentData);
        Swal.fire({
          icon: "success",
          title: "Assessment berhasil diupdate",
          confirmButtonColor: "#0F62FE",
        });
      } else {
        // Create new assessment
        const newAssessment = await createBuildingAssessment(assessmentData);
        setCurrentAssessmentId(newAssessment.id);
        Swal.fire({
          icon: "success",
          title: "Assessment berhasil dibuat",
          confirmButtonColor: "#0F62FE",
        });
      }

      setOpenAddAssessmentDialog(false);
      fetchAssessments();
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal menyimpan assessment",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleOpenEditAssessment = (assessment: any) => {
    setAssessmentData({
      id: assessment.id,
      officeId: assessment.officeId,
      assessmentDate: assessment.assessmentDate,
      picName: assessment.picName,
      assessmentType: assessment.assessmentType,
      status: assessment.status
    });

    const selectedOffice = officeOptions.find(office => office.officeId === assessment.officeId);
    if (selectedOffice) {
      setSelectedOffice({
        id: selectedOffice.id,
        name: selectedOffice.name,
        address: selectedOffice.address
      });
    }

    setOpenAddAssessmentDialog(true);
  };

  const handleOpenAssessmentDetail = async (assessmentId: string) => {
    setCurrentAssessmentId(assessmentId);
    try {
      const details = await getAssessmentDetails({ assessmentId });
      setAssessmentDetails(details.data || details);
    } catch (error) {
      console.error("Failed to fetch assessment details:", error);
      setAssessmentDetails([]);
    }
    setOpenAssessmentDetailDialog(true);
  };

  const handleAddAssessmentDetail = async () => {
    if (!assessmentDetailData.subSection || !assessmentDetailData.damageItem) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Sub Bagian dan Kerusakan/Item harus diisi",
      });
      return;
    }

    try {
      const newDetail = {
        assessmentId: currentAssessmentId,
        ...assessmentDetailData
      };

      await createAssessmentDetail(newDetail);

      const details = await getAssessmentDetails({ assessmentId: currentAssessmentId });
      setAssessmentDetails(details.data || details);

      // Reset form
      setAssessmentDetailData({
        subSection: "",
        damageItem: "",
        condition: "",
        length: 0,
        width: 0,
        height: 0,
        notes: "",
        evidenceFile: null
      });

      Swal.fire({
        icon: "success",
        title: "Detail assessment berhasil ditambahkan",
        confirmButtonColor: "#0F62FE",
      });
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal menambahkan detail assessment",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleDeleteAssessmentDetail = async (detailId: string) => {
    try {
      await deleteAssessmentDetail(detailId);

      const details = await getAssessmentDetails({ assessmentId: currentAssessmentId });
      setAssessmentDetails(details.data || details);

      Swal.fire({
        icon: "success",
        title: "Detail assessment berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus detail assessment",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleSearch = async () => {
    setIsLoading(true);
    setError("");
    try {
      await fetchAssessments();
    } catch (err: any) {
      setError(err.message || "Search failed");
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const exportData = rows.map(assessment => ({
        'Office Name': assessment.office?.name || '-',
        'Office Address': assessment.office?.address || '-',
        'Assessment Date': assessment.assessmentDate || '-',
        'PIC Name': assessment.picName || '-',
        'Assessment Type': assessmentTypes.find(type => type.value === assessment.assessmentType)?.label || assessment.assessmentType,
        'Status': statusOptions.find(status => status.value === assessment.status)?.label || assessment.status,
        'Total Items': assessment.totalItems || 0,
        'Created At': assessment.createdAt || '-'
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Building Assessments");

      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Building_Assessments_${date}.xlsx`);

      Swal.close();
    } catch (error: any) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export assessment data',
      });
    }
  };

  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  return (
    isLoading ? <LoadingOverlay /> :
      <Box sx={{ padding: 3 }}>
        {/* Header */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
          <Assessment sx={{ fontSize: 30, color: "primary.main" }} />
          <Typography variant="h6" fontWeight="bold">
            Building Assessment List
          </Typography>
        </Box>

        {/* Toolbar */}
        <Box className="toolbar">
          {/* Left Controls */}
          <Box className="leftControls">
            <Typography>Show</Typography>
            <Select
              value={rowsPerPage}
              onChange={(e: SelectChangeEvent<number>) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              size="small"
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>

            {/* Search Button & Input */}
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={() => setShowSearch((prev) => !prev)}
              className="searchButton"
            >
              Search
            </Button>
            {showSearch && (
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search by office name, PIC, or type"
                value={searchQuery}
                onChange={async (e) => {
                  await setSearchQuery(e.target.value);
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                autoFocus
                className="searchInput"
              />
            )}

            {error && <p style={{ color: "red" }}>{error}</p>}
          </Box>

          {/* Right Controls */}
          <Box className="rightControls">
            <Button
              startIcon={<Delete />}
              variant="text"
              onClick={() => {
                const selectedData = rows.filter((row) => selectedRows.includes(row.id));
                setItemsToDelete(selectedData);
                setOpenDeleteDialog(true);
              }}
              disabled={selectedRows.length === 0}
            >
              Delete
            </Button>
            <Button
              startIcon={<Download />}
              variant="contained"
              className="exportButton"
              onClick={() => handleExport()}
            >
              Export
            </Button>
            <Button
              startIcon={<Add />}
              variant="contained"
              className="addItemDetailsButton"
              onClick={() => {
                setAssessmentData({
                  officeId: "",
                  assessmentDate: dayjs().format("YYYY-MM-DD"),
                  picName: "",
                  assessmentType: "",
                  status: "DRAFT"
                });
                setSelectedOffice({
                  id: "",
                  name: "",
                  address: ""
                });
                setOpenAddAssessmentDialog(true);
              }}
            >
              Add New Assessment
            </Button>
          </Box>
        </Box>

        {/* Delete Button & Subtitle */}
        <Box className="deleteContainer">
          <Typography variant="body2" className="detailsSubtitle">
            Details List Of All Building Assessments
          </Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} className="tableContainer">
          <Table className="table">
            <TableHead className="tableHead">
              <TableRow>
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                    checked={selectedRows.length === rows.length}
                    onChange={() =>
                      setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.id))
                    }
                  />
                </TableCell>
                <TableCell>No</TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("office.name")} style={{ cursor: "pointer" }}>
                  <strong>Office Location</strong>
                  {sortConfig.orderBy === "office.name" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("totalItems")} style={{ cursor: "pointer" }}>
                  <strong>Total Items</strong>
                  {sortConfig.orderBy === "totalItems" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("assessmentType")} style={{ cursor: "pointer" }}>
                  <strong>Assessment Type</strong>
                  {sortConfig.orderBy === "assessmentType" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("assessmentDate")} style={{ cursor: "pointer" }}>
                  <strong>Assessment Date</strong>
                  {sortConfig.orderBy === "assessmentDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                  <strong>Status Assessment</strong>
                  {sortConfig.orderBy === "status" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell">
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedRows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  <TableCell padding="checkbox" className="tableCell">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </TableCell>
                  <TableCell>{offset + index + 1}</TableCell>
                  <TableCell className="tableCell">
                    <Box>
                      <Typography fontWeight="bold">{row.office?.name}</Typography>
                      <Typography variant="caption" color="textSecondary">
                        {row.office?.address}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell className="tableCell">{row.totalItems || 0}</TableCell>
                  <TableCell className="tableCell">
                    {assessmentTypes.find(type => type.value === row.assessmentType)?.label || row.assessmentType}
                  </TableCell>
                  <TableCell className="tableCell">{row.assessmentDate}</TableCell>
                  <TableCell className="tableCell">
                    <Chip
                      label={statusOptions.find(status => status.value === row.status)?.label || row.status}
                      color={statusOptions.find(status => status.value === row.status)?.color as any}
                      size="small"
                    />
                  </TableCell>
                  <TableCell className="tableCell">
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <IconButton
                        size="small"
                        onClick={() => handleOpenEditAssessment(row)}
                        title="Edit Assessment"
                      >
                        <Edit fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleOpenAssessmentDetail(row.id.toString())}
                        title="View Details"
                      >
                        <Visibility fontSize="small" />
                      </IconButton>

                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <Box className="paginationContainer">
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {`Showing ${offset + 1} to ${Math.min(
              offset + rowsPerPage,
              totalItems
            )} of ${totalItems} entries`}
          </Typography>

          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, page) => setCurrentPage(page)}
            className="pagination"
            showFirstButton
            showLastButton
            renderItem={(item) => (
              <PaginationItem
                {...item}
                components={{ first: FirstPage, last: LastPage }}
              />
            )}
          />
        </Box>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
          <DialogTitle>Delete Assessments?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete the selected {selectedRows.length} assessment(s)?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
            <Button onClick={handleDeleteRows} color="error">Delete</Button>
          </DialogActions>
        </Dialog>

        {/* Modal Create/Edit Building Assessment */}
        <Dialog
          open={openAddAssessmentDialog}
          onClose={() => setOpenAddAssessmentDialog(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">
                {assessmentData.id ? "Edit Building Assessment" : "Add New Building Assessment"}
              </Typography>
              <IconButton onClick={() => setOpenAddAssessmentDialog(false)} color="error">
                <Close />
              </IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ mt: 2 }}>
              {/* <FormControl fullWidth margin="normal">
                <InputLabel>Office Name *</InputLabel>
                <Select
                  value={assessmentData.officeId}
                  onChange={handleOfficeChange}
                  label="Office Name *"
                  name="officeId"
                >
                  <MenuItem value="">
                    <em>Select Office</em>
                  </MenuItem>
                  {officeOptions.map((office) => (
                    <MenuItem key={office.id} value={office.id}>
                      {office.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              <Autocomplete
                fullWidth
                options={officeOptions}
                getOptionLabel={(option) => option.office?.officeName || ""}
                value={officeOptions.find(opt => opt.officeId === assessmentData.officeId) || null}
                onChange={(event, newValue) => {
                  handleOfficeChange({
                    target: {
                      name: "officeId",
                      value: newValue ? newValue.officeId : ""
                    }
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Office Location *" 
                    name="officeId"
                    placeholder="Search office location"
                    fullWidth
                    error={!assessmentData.officeId}
                    helperText={!assessmentData.officeId ? "Mandatory Field" : ""}
                  />
                )}
              />

              <TextField
                fullWidth
                label="Office Address"
                value={selectedOffice.office?.officeAddress || ""}
                margin="normal"
                disabled
              />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="Assessment Date *"
                  format="YYYY-MM-DD"
                  value={assessmentData.assessmentDate ? dayjs(assessmentData.assessmentDate) : null}
                  onChange={(newValue) => {
                    setAssessmentData({
                      ...assessmentData,
                      assessmentDate: newValue ? newValue.format("YYYY-MM-DD") : ""
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      margin: "normal",
                    },
                  }}
                />
              </LocalizationProvider>

              <TextField
                fullWidth
                label="PIC Name"
                name="picName"
                value={assessmentData.picName}
                onChange={handleInputChange}
                margin="normal"
                placeholder="Enter PIC Name"
              />

              <FormControl fullWidth margin="normal">
                <InputLabel>Assessment Type *</InputLabel>
                <Select
                  value={assessmentData.assessmentType}
                  onChange={(e: SelectChangeEvent) => setAssessmentData({ ...assessmentData, assessmentType: e.target.value })}
                  label="Assessment Type *"
                  name="assessmentType"
                >
                  <MenuItem value="">
                    <em>Select Assessment Type</em>
                  </MenuItem>
                  {assessmentTypes.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth margin="normal">
                <InputLabel>Status *</InputLabel>
                <Select
                  value={assessmentData.status || "DRAFT"}
                  onChange={(e: SelectChangeEvent) => setAssessmentData({ ...assessmentData, status: e.target.value })}
                  label="Status *"
                >
                  {statusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            <Button
              variant="outlined"
              color="error"
              sx={{ width: 120 }}
              onClick={() => setOpenAddAssessmentDialog(false)}
            >
              CANCEL
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ width: 120 }}
              onClick={handleSubmitAssessment}
            >
              SAVE
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal Assessment Detail (Sipil) */}
        <Dialog
          open={openAssessmentDetailDialog}
          onClose={() => setOpenAssessmentDetailDialog(false)}
          fullWidth
          maxWidth="lg"
        >
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">
                Assessment Details - Sipil
              </Typography>
              <IconButton onClick={() => setOpenAssessmentDetailDialog(false)} color="error">
                <Close />
              </IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ mt: 2 }}>
              {/* Form untuk menambah detail assessment */}
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Add Assessment Detail
              </Typography>

              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 3 }}>
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel>Bagian (Sub) *</InputLabel>
                  <Select
                    value={assessmentDetailData.subSection}
                    onChange={(e: SelectChangeEvent) => setAssessmentDetailData({
                      ...assessmentDetailData,
                      subSection: e.target.value as string,
                      damageItem: "" // Reset damage item when sub section changes
                    })}
                    label="Bagian (Sub) *"
                    name="subSection"
                  >
                    <MenuItem value="">
                      <em>Select Sub Section</em>
                    </MenuItem>
                    {Object.entries(sipilMasterData).map(([section, items]) => (
                      <optgroup key={section} label={section}>
                        {items.map((item) => (
                          <MenuItem key={item.subSection} value={item.subSection}>
                            {item.subSection}
                          </MenuItem>
                        ))}
                      </optgroup>
                    ))}
                  </Select>
                </FormControl>

                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel>Kerusakan / Item *</InputLabel>
                  <Select
                    value={assessmentDetailData.damageItem}
                    onChange={(e: SelectChangeEvent) => setAssessmentDetailData({
                      ...assessmentDetailData,
                      damageItem: e.target.value as string
                    })}
                    label="Kerusakan / Item *"
                    name="damageItem"
                    disabled={!assessmentDetailData.subSection}
                  >
                    <MenuItem value="">
                      <em>Select Damage/Item</em>
                    </MenuItem>
                    {assessmentDetailData.subSection &&
                      Object.entries(sipilMasterData).map(([section, items]) => {
                        const subSectionItems = items.find(item => item.subSection === assessmentDetailData.subSection);
                        return subSectionItems?.damageItems.map((damageItem) => (
                          <MenuItem key={damageItem} value={damageItem}>
                            {damageItem}
                          </MenuItem>
                        ));
                      })
                    }
                  </Select>
                </FormControl>

                <FormControl sx={{ minWidth: 150 }}>
                  <InputLabel>Kondisi</InputLabel>
                  <Select
                    value={assessmentDetailData.condition}
                    onChange={(e: SelectChangeEvent) => setAssessmentDetailData({
                      ...assessmentDetailData,
                      condition: e.target.value as string
                    })}
                    label="Kondisi"
                    name="condition"
                  >
                    <MenuItem value="">
                      <em>Select Condition</em>
                    </MenuItem>
                    {conditionOptions.map((condition) => (
                      <MenuItem key={condition.value} value={condition.value}>
                        {condition.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  label="Panjang (m)"
                  name="length"
                  type="number"
                  value={assessmentDetailData.length}
                  onChange={handleAssessmentDetailChange}
                  sx={{ width: 120 }}
                />

                <TextField
                  label="Lebar (m)"
                  name="width"
                  type="number"
                  value={assessmentDetailData.width}
                  onChange={handleAssessmentDetailChange}
                  sx={{ width: 120 }}
                />

                <TextField
                  label="Tinggi (m)"
                  name="height"
                  type="number"
                  value={assessmentDetailData.height}
                  onChange={handleAssessmentDetailChange}
                  sx={{ width: 120 }}
                />
              </Box>

              <Box sx={{ mb: 3 }}>
                <TextField
                  fullWidth
                  label="Keterangan"
                  name="notes"
                  value={assessmentDetailData.notes}
                  onChange={handleAssessmentDetailChange}
                  multiline
                  rows={2}
                />
              </Box>

              <Box sx={{ mb: 3 }}>
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<PhotoCamera />}
                >
                  Upload Evidence
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        setAssessmentDetailData({
                          ...assessmentDetailData,
                          evidenceFile: file
                        });
                      }
                    }}
                  />
                </Button>
                {assessmentDetailData.evidenceFile && (
                  <Typography variant="caption" sx={{ ml: 2 }}>
                    {assessmentDetailData.evidenceFile.name}
                  </Typography>
                )}
              </Box>

              <Button
                variant="contained"
                color="primary"
                onClick={handleAddAssessmentDetail}
                sx={{ mb: 3 }}
              >
                Add Assessment Detail
              </Button>

              {/* Tabel Assessment Details */}
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Assessment Details List
              </Typography>

              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>Bagian (Sub)</TableCell>
                      <TableCell>Kerusakan / Item</TableCell>
                      <TableCell>Kondisi</TableCell>
                      <TableCell>Ukuran (PxLxT)</TableCell>
                      <TableCell>Keterangan</TableCell>
                      <TableCell>Foto</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {assessmentDetails.map((detail, index) => (
                      <TableRow key={detail.id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{detail.subSection}</TableCell>
                        <TableCell>{detail.damageItem}</TableCell>
                        <TableCell>
                          {conditionOptions.find(cond => cond.value === detail.condition)?.label || detail.condition}
                        </TableCell>
                        <TableCell>
                          {detail.length && detail.width && detail.height
                            ? `${detail.length}m x ${detail.width}m x ${detail.height}m`
                            : "-"
                          }
                        </TableCell>
                        <TableCell>{detail.notes || "-"}</TableCell>
                        <TableCell>
                          {detail.evidenceUrl ? (
                            <IconButton
                              size="small"
                              onClick={() => window.open(detail.evidenceUrl, '_blank')}
                            >
                              <PhotoCamera />
                            </IconButton>
                          ) : "-"}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteAssessmentDetail(detail.id)}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                    {assessmentDetails.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          No assessment details found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </DialogContent>

          <DialogActions sx={{ padding: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenAssessmentDetailDialog(false)}
            >
              CLOSE
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
  );
};

export default BuildingAssessmentPage;